<template>
  <div style="height: 700px;">
    <!-- 头像 -->
    <!-- 在使用Vue.js框架时，:src（或者更详细地说，v-bind:src）是一种绑定语法，用于将属性值绑定到Vue实例中的数据属性。这个绑定允许你动态地设置属性值，而不仅仅是使用静态字符串。 -->
    <div id="userinfoTitle">
      <!-- 参数说明:
        1.	action:必选参数，上传的地址
        2. show-file-list:是否显示已上传文件列表 ,true展示,false不展示
        3.on-success:文件上传成功时的钩子
        4.before-upload:上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
        5.auto-upload:是否在选取文件后立即进行上传,默认是true,立即上传
          -->

      <el-upload
        class="avatar-uploader"
        :action="baseUrl+'/headSculptureUpload'"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
        :auto-upload="true"
        :data="userData.data"
      >
        <Avatar v-if="imageUrl" :src="imageUrl" size="50px" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>

    <span id="spanData">
      <!-- 使用card标签 -->
      <el-card class="box-card">
        <!-- 中间内容区域 -->
        <el-form :label-position="labelPosition" label-width="80px">
          <el-form-item label="用户名">
            <el-input
              :disabled="true"
              v-model="userData.data.userName"
            ></el-input>
          </el-form-item>
          <el-form-item label="昵称">
            <el-input v-model="userData.data.nickName"></el-input>
          </el-form-item>
          <el-form-item label="积分">
            <el-input
              :disabled="true"
              v-model="userData.data.pricePo.price"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机">
            <el-input v-model="userData.data.phone"></el-input>
          </el-form-item>

          <el-form-item label="邮箱">
            <el-input :disabled="true" v-model="userData.data.email"></el-input>
          </el-form-item>
        </el-form>

        <!-- 两个按钮 -->
        <el-button @click="saveInfo()" type="primary">保存</el-button>
      </el-card>
    </span>
  </div>
</template>

<script>
import Avatar from "./avatar.vue";
import { saveInfo, findUserByUserId } from "@/api/editUser.js";
import { mapMutations, mapState } from "vuex";

export default {
  // 使用组件
  components: {
    Avatar: Avatar,
  },
  data() {
    return {
      // 用户的反显数据
      userData: {},
      // 定义头像，这里应从前端缓存获取
      imageUrl: "",
      // 点击保存，上传的对象
      userDataRequest: {
        userId: "",
        userName: "",
        nickName: "",
        phone: "",
        gender: "",
        age: "",
        headSculpture: "",
        email: "",
        birthday: "",
        imageUrl: "",
      },

      // 内容显示的位置
      labelPosition: "right",
    };
  },

  // 计算属性
  computed: {
    ...mapState(["userPullDownData"]),
    baseUrl() {
      // 获取main.js中定义的公共参数地址
      return this.$baseUrl;
    },
  },

  methods: {
    // 点击保存后，调用该方法
    async saveInfo() {
      console.log("获取要保存的数据为：" + JSON.stringify(this.userData));
      // 对请求数据赋值
      this.userDataRequest.userId = this.userData.data.userId;
      this.userDataRequest.userName = this.userData.data.userName;
      this.userDataRequest.nickName = this.userData.data.nickName;
      this.userDataRequest.phone = this.userData.data.phone;
      this.userDataRequest.gender = this.userData.data.gender === "男" ? 1 : 0;
      this.userDataRequest.age = this.userData.data.age;
      this.userDataRequest.headSculpture = this.userData.data.headSculpture;
      this.userDataRequest.email = this.userData.data.email;
      this.userDataRequest.birthday = this.userData.data.birthday;

      // 调用后端保存接口
      const res = await saveInfo(this.userDataRequest);
      console.log("保存，获取的响应数据为：" + JSON.stringify(res));
      // 当保存成功后，需要改本地缓存数据
      if (res.status === "200") {
        // 进行提示
        this.$message({
          message: res.message,
          type: "success",
        });

        // 更改本地缓存
        const loginRes = await findUserByUserId(this.userData.data.userId);
        // 获取用户密码，调用login接口

        console.log("通过userId查询出来的数：" + JSON.stringify(loginRes));
        // 对data中的用户性别进行转换，1：男，0：女
        const gender = loginRes.data.gender;
        if (!(gender === "" || gender === null)) {
          loginRes.data.gender = gender == 1 ? "男" : "女";
        }
        localStorage.setItem("accessUserData", JSON.stringify(loginRes));
      }
    },

    // 点击返回后调用，返回到首页
    back() {
      console.log("返回首页");
      // 返回到上一页
      this.$router.back();
    },

    // 文件上传成功时的钩子
    handleAvatarSuccess(res, file) {
      console.log(
        "头像上传成功："+JSON.stringify(res)
      );
      this.imageUrl = res.data;
    },
    // 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeAvatarUpload(file) {
      console.log("获取的类型为：" + file.type);
      const isJPG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },

  //   已进入页面开始调用created函数
  created() {
    // 设置左侧TabName选中值为1
    this.$store.commit("changeTabPaneName", "1");

    // 获取本地缓存中的数据
    const accessUserData = localStorage.getItem("accessUserData");
    console.log("已进入用户信息页面2" + accessUserData);
    // 转换为对象
    this.userData = JSON.parse(accessUserData);
    // 给头像地址赋值
    this.imageUrl = this.userData.data.headsculpture;
  },
};
</script>

<style scoped>
/* card卡片属性 */
.box-card {
  width: 480px;
  text-align: center;
}
#spanData {
  display: flex;
  justify-content: center;
}

/* 头像样式 */
.avatar-uploader {
  text-align: center;
}
</style>